// src/api/auth.ts
import { LoginCredentials, LoginResponse, User } from '../types';
import api from './config';

export const authApi = {
  login: async (credentials: LoginCredentials & { otp_token?: string; backup_token?: string }): Promise<LoginResponse> => {
    const response = await api.post('/api/token/', credentials);
    return response.data;
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await api.get('/api/users/me/');
    return response.data;
  },

  refreshToken: async (refresh: string): Promise<{ access: string }> => {
    const response = await api.post('/api/token/refresh/', { refresh });
    return response.data;
  },

  changePassword: async (data: {
    current_password: string;
    new_password: string;
    confirm_password: string;
  }) => {
    const response = await api.post('/api/users/change_password/', data);
    return response.data;
  },

  // MFA endpoints
  mfaSetup: async () => {
    const response = await api.get('/api/users/mfa_setup/');
    return response.data;
  },

  mfaEnable: async (data: { otp_token: string }) => {
    const response = await api.post('/api/users/mfa_enable/', data);
    return response.data;
  },

  mfaDisable: async (data: { otp_token?: string; backup_token?: string }) => {
    const response = await api.post('/api/users/mfa_disable/', data);
    return response.data;
  },

  mfaStatus: async () => {
    const response = await api.get('/api/users/mfa_status/');
    return response.data;
  },

  mfaRegenerateBackupTokens: async (data: { otp_token?: string; backup_token?: string }) => {
    const response = await api.post('/api/users/mfa_regenerate_backup_tokens/', data);
    return response.data;
  },

  mfaVerify: async (data: { 
    email: string; 
    password: string; 
    otp_token?: string; 
    backup_token?: string 
  }) => {
    const response = await api.post('/api/mfa/verify/', data);
    return response.data;
  },
};